module.exports = __webpack_public_path__ + "static/media/breakfast.e4698bf7.svg";